import { render, staticRenderFns } from "./CustomizationOfferTable.vue?vue&type=template&id=2b216859&scoped=true"
import script from "./CustomizationOfferTable.vue?vue&type=script&lang=js"
export * from "./CustomizationOfferTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b216859",
  null
  
)

export default component.exports